import { render, staticRenderFns } from "./GoalBoard.vue?vue&type=template&id=593091b9&"
import script from "./GoalBoard.vue?vue&type=script&lang=js&"
export * from "./GoalBoard.vue?vue&type=script&lang=js&"
import style0 from "./GoalBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports